import {NavLink, useParams} from "react-router-dom";
import api from "../../api";
import {useEffect, useRef, useState} from "react";
import Header from "./Components/Header";
import {RecipeData} from "../types/Page";
import PageHero from "./Components/PageHero";
import discover from '../../assets/images/Discover The Secret Ingredient.svg';
import '../../styles/Recipes.scss'
import FooterWithSignup from "./Components/FooterWithSignup";
import {IMAGE_URL} from "../../path";
import difficulty from '../../assets/images/difficulty.svg';
import minutes from '../../assets/images/minutes.svg';

function Recipes() {
    const { slug } = useParams();

    const [recipeData, setRecipeData] = useState<RecipeData | null>(null);
    const [optionsOpen, setOptionsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const filterRef = useRef<HTMLDivElement>(null);

    async function fetchRecipes(page: number = 1) {
        try {
            let res;

            if (slug) {
                res = await api.get(`/v1/recipes/${slug}?page=${page}`);
            } else {
                res = await api.get(`/v1/recipes?page=${page}`);
            }

            console.log(res);

            setRecipeData(res.data);
        } catch (e) {
            console.error(e);
        }
    }

    function handlePageChange(page: number) {
        setCurrentPage(page);
        fetchRecipes(page);
    }

    useEffect(() => {
        setCurrentPage(1);
        fetchRecipes(1);
    }, [slug]);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                filterRef.current &&
                !filterRef.current.contains(event.target as Node)
            ) {
                setOptionsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div>
            <Header />

            {recipeData &&
                recipeData.page &&
                recipeData.page.headers && (
                    <PageHero
                        headers={recipeData.page.headers}
                        page={recipeData.page.slug}
                    />
                )}

            {recipeData &&
                recipeData.recipe_count &&
                recipeData.cat_count && (
                    <div className="recipes-intro">

                        <div className="recipes-image">
                            <img
                                src={discover}
                                alt="Discover the Secret Ingredient"
                            />
                        </div>

                        <div className="recipes-top-inner">

                            <div className="left">
                                <p>
                                    When it comes to cooking, vinegar stands out as a fantastically versatile ingredient with impressive range and potency.
                                </p>

                                <p>
                                    Vinegar can perform many useful functions in recipes such as improving flavour, food preservation, substituting in for missing ingredients and improving the appearance of the meal.
                                </p>

                                <p>
                                    One thing’s for certain, vinegar is a secret ingredient for just about any meal occasion.
                                </p>
                            </div>

                            <div className="right">

                                <div className="intro">
                                    <div className="total">
                                        <div className="title">
                                            {recipeData.recipe_count}
                                        </div>

                                        <div className="desc">
                                            Total Recipes
                                        </div>
                                    </div>

                                    <div className="total">
                                        <div className="title">
                                            {recipeData.cat_count}
                                        </div>

                                        <div className="desc">
                                            Collections
                                        </div>
                                    </div>
                                </div>

                                {recipeData.categories &&
                                    recipeData.categories.length > 0 && (
                                        <div className="news-filter">

                                            <div
                                                className="filter-box"
                                                ref={filterRef}
                                            >
                                                <button
                                                    type="button"
                                                    className="filter-toggle"
                                                    onClick={() =>
                                                        setOptionsOpen(!optionsOpen)
                                                    }
                                                >
                                                    <span>
                                                        Filter By:{" "}

                                                        {slug
                                                            ? recipeData.categories.find(
                                                            (category) =>
                                                                category.slug === slug
                                                        )?.name || "All"
                                                            : "All"}
                                                    </span>

                                                    <span
                                                        className={`filter-arrow ${
                                                            optionsOpen
                                                                ? "open"
                                                                : ""
                                                        }`}
                                                    >
                                                    </span>
                                                </button>

                                                {optionsOpen && (
                                                    <div className="filter-options">

                                                        <NavLink
                                                            to="/recipes"
                                                            onClick={() =>
                                                                setOptionsOpen(false)
                                                            }
                                                        >
                                                            All
                                                        </NavLink>

                                                        {recipeData.categories.map(
                                                            (category) => (
                                                                <NavLink
                                                                    key={category.id}
                                                                    to={`/recipes/${category.slug}`}
                                                                    onClick={() =>
                                                                        setOptionsOpen(false)
                                                                    }
                                                                >
                                                                    {category.name}
                                                                </NavLink>
                                                            )
                                                        )}

                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    )}
                            </div>

                        </div>

                        {/* Recipes */}
                        <div className="recipes-grid">
                            <div className="recipes-grid-inner">

                                {recipeData.recipes.data.map((recipe) => (
                                    <article
                                        className="recipe-card"
                                        key={recipe.id}
                                    >
                                        <div className="recipe-image">
                                            <img
                                                src={`${IMAGE_URL}/${recipe.preview_image}`}
                                                alt={recipe.name}
                                            />
                                        </div>

                                        {recipe.category?.icon && (
                                            <div className="recipe-category-icon">
                                                <img
                                                    src={`${IMAGE_URL}/${recipe.category.icon}`}
                                                    alt={recipe.category.name}
                                                />
                                            </div>
                                        )}

                                        <div className="recipe-content">

                                            <div className="recipe-read-time">
                                                {/*{recipe.read_time} min read*/}
                                                <div className="item">
                                                    <img src={minutes} alt="Minutes" />
                                                    <div className="time">{recipe.overall_time}</div>
                                                </div>
                                                <div className="item">
                                                    <img src={difficulty} alt="Difficulty" />
                                                    <div className="time">{recipe.difficulty}</div>
                                                </div>

                                            </div>

                                            <h3>
                                                {recipe.name}
                                            </h3>

                                            <p>
                                                {recipe.preview_body}
                                            </p>

                                            <NavLink
                                                to={`/recipe/${recipe.slug}`}
                                                className="recipe-read-more"
                                            >
                                                Read More
                                            </NavLink>

                                        </div>
                                    </article>
                                ))}

                            </div>
                        </div>



                        {/* Pagination */}
                        <div className="pagination">
                            <button
                                type="button"
                                disabled={recipeData.recipes.current_page === 1}
                                onClick={() =>
                                    handlePageChange(recipeData?.recipes.current_page - 1)
                                }
                                className="pagination-arrow"
                            >
                                &lt;
                            </button>

                            <div className="pagination-numbers">
                                {Array.from(
                                    { length: recipeData.recipes.last_page },
                                    (_, index) => index + 1
                                ).map((page) => (
                                    <button
                                        key={page}
                                        type="button"
                                        className={`pagination-number ${
                                            page === recipeData.recipes.current_page
                                                ? "active"
                                                : ""
                                        }`}
                                        onClick={() => handlePageChange(page)}
                                    >
                                        {page}
                                    </button>
                                ))}
                            </div>

                            <button
                                type="button"
                                disabled={
                                    recipeData.recipes.current_page ===
                                    recipeData.recipes.last_page
                                }
                                onClick={() =>
                                    handlePageChange(recipeData?.recipes.current_page + 1)
                                }
                                className="pagination-arrow"
                            >
                                &gt;
                            </button>
                        </div>

                    </div>
                )}

            <FooterWithSignup />
        </div>
    );
}

export default Recipes;
